import { createFileRoute, linkOptions } from '@tanstack/react-router'
import { useAtomValue } from 'jotai'
import { useTranslation } from 'react-i18next'
import z from 'zod'

import NotFoundResource from '@/components/router/not-found-resource'
import RouteSheet from '@/components/sheets/route-sheet'
import { pageSearchAtom } from '@/stores/page-search.atom'

import { Route as CoveragesRoute } from '../route'

const params = z.object({
  uuid: z.uuid(),
})

export const Route = createFileRoute('/app/analysis/coverages/$uuid')({
  component: RouteComponent,
  params,
  errorComponent: (props) => {
    const { t } = useTranslation()

    return (
      <NotFoundResource
        {...props}
        resourceType={t('resource-not-found.not-found.coverage.resource-type')}
        backTo={t(
          'resource-not-found.not-found.coverage.back-to-coverages-list',
        )}
        backToLink={backToLink}
      />
    )
  },
})

const backToLink = linkOptions({
  from: Route.fullPath,
  to: '..',
})

function RouteComponent() {
  const pageSearch = useAtomValue(pageSearchAtom)
  const closeLink =
    pageSearch[CoveragesRoute.fullPath] ??
    linkOptions({ to: CoveragesRoute.fullPath })

  return <RouteSheet closeLink={closeLink} />
}
